import { FC } from 'react'
import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'

import { RootState } from 'dataStore/state'
import { useRole } from 'hooks/useRole'

import PizzeriaFilter from './PizzeriaFilter'
import OrderTypeFilter from './OrderTypeFilter'
import PaymentTypeFilter from './PaymentTypeFilter'
import PaymentStatusFilter from './PaymentStatusFilter'

/**
 * Фильтры таблицы заказов.
 * Фильтр пиццерий скрыт у субадмина, если у него не больше одной пиццерии
 * (список пиццерий уже ограничен API `/pizzerias/all`).
 */
const Filters: FC = () => {
  const { pizzerias } = useSelector((state: RootState) => state.pizzerias)
  const { isSubAdmin, isRoleReady } = useRole()

  const accessiblePizzeriasCount = pizzerias?.length ?? 0
  const showPizzeriaFilter =
    isRoleReady && (!isSubAdmin || accessiblePizzeriasCount > 1)

  const filterColumnMd = showPizzeriaFilter ? 3 : 4

  return (
    <Grid container spacing={3} sx={{ mb: '25px' }}>
      {showPizzeriaFilter && (
        <Grid item xs={12} sm={6} md={filterColumnMd}>
          <PizzeriaFilter />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={filterColumnMd}>
        <OrderTypeFilter />
      </Grid>
      <Grid item xs={12} sm={6} md={filterColumnMd}>
        <PaymentTypeFilter />
      </Grid>
      <Grid item xs={12} sm={6} md={filterColumnMd}>
        <PaymentStatusFilter />
      </Grid>
    </Grid>
  )
}

export default Filters
